import { useDispatch, useSelector } from 'react-redux';
import { IStore } from '../../common/store';
import { getCustomiseSection } from '../store/selectors/customiseSelectors';
import { customiseActions } from '../store/reducers/customiseReducer';
import { TSectionsKeys } from '../model/IStoreTypes';

const useAccordionStoreState = (sectionName: TSectionsKeys) => {
  const dispatch = useDispatch();
  const currentSection = useSelector((state: IStore) => getCustomiseSection(state, sectionName));
  const setExpanded = (expanded: boolean) => {
    dispatch(customiseActions.setAccordionStatus({ name: sectionName, expanded }));
  };

  return { expanded: currentSection.expanded, setExpanded };
};

export default useAccordionStoreState;
